<template>
  <SBtn
    v-show="href"
    :href="href"
    text
    target="_blank"
    rel="noreferrer"
    class="mx-1"
    :data-testid="name"
  >
    <VIcon color="hover" :size="iconSize">
      {{ icon }}
    </VIcon>
  </SBtn>
</template>

<script setup lang="ts">
interface Props {
  href?: string
  name?: string
  icon: string
  iconSize?: number
}
withDefaults(defineProps<Props>(), {
  href: '',
  name: undefined,
  iconSize: 24
})
</script>

<style lang="scss" scoped>
</style>
